/**
 * Cart request as system event
 * @returns {object}
 */
export default () => ({
	event: 'system.cartRequest',
	system: {
		cartRequest: {}
	}
});
